import React, { useEffect } from 'react';
import '../../../css/v2/AppV2Wizard.scss';
import {Modal as PModal, TextField, TextStyle, Icon} from "@shopify/polaris";
import {
  PlayCircleMajor
} from '@shopify/polaris-icons';
import {Modal as AntModal} from 'antd';
import "video-react/dist/video-react.css";
import { Player,BigPlayButton } from 'video-react';
import VisibleSendEvent from "../../../containers/global/VisibleSendEvent";

const htmlPerOfferType = {
    cross_sell: `<div class="zrx-widget-slider">
        <div class="zrx-frequently-bought-together" style="max-width: 100%; padding: 8px;">
            <div class="zrx-slider-title-wrapper">
                <h2 class="zrx-slider-main-title" style="text-align: center; font-size: 14px; margin: 0 0 8px 0; color: #333; font-weight: 600;">Frequently Bought Together ✨</h2>
            </div>
            <div class="zrx-slider-carousel-wrapper">
                <div class="zrx-slider-list-container">
                    <ul class="zrx-slider-list-wrapper" style="display: flex; gap: 8px; list-style: none; padding: 0; margin: 0;">
                        <li class="zrx-slider-list-item" style="flex: 1; min-width: 0;">
                            <div class="zrx-slider-product-image-div-warpper">
                                <div class="zrx-slider-product-image-div" style="width: 100%; padding-bottom: 70%; position: relative; background: #f5f5f5; border-radius: 4px; margin-bottom: 6px;">
                                    <div class="zrx-slider-product-image" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-image: url('https://cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-891920315_450x.jpg?v=1595145673'); background-size: cover; background-position: center; border-radius: 4px;"></div>
                                </div>
                            </div>
                            <div class="zrx-slider-product-details-div">
                                <a class="zrx-slider-product-name" style="display: block; font-size: 9px; font-weight: 500; color: #333; text-decoration: none; margin-bottom: 3px; line-height: 1.2; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: center;">Women Blouses Tops</a>
                                <div class="zrx-slider-item-price">
                                    <span class="zrx-slider-product-price-wrapper" style="display: flex; justify-content: center; gap: 4px; margin-bottom: 6px;">
                                        <span class="zrx-slider-product-price zrx-compare" style="color: #999; text-decoration: line-through; font-size: 9px;">$22.34</span>
                                        <span class="zrx-slider-product-price zrx-regular" style="color: #008060; font-weight: 600; font-size: 9px;">$20.11</span>
                                    </span>
                                </div>
                                <div class="zrx-slider-variants-wrapper">
                                    <button class="zrx-slider-add-to-cart-button" style="width: 100%; background: #008060; color: white; border: none; padding: 6px; border-radius: 4px; font-size: 10px; cursor: pointer; font-weight: 500;">Add to cart</button>
                                </div>
                            </div>
                        </li>
                        <li class="zrx-slider-list-item" style="flex: 1; min-width: 0;">
                            <div class="zrx-slider-product-image-div-warpper">
                                <div class="zrx-slider-product-image-div" style="width: 100%; padding-bottom: 70%; position: relative; background: #f5f5f5; border-radius: 4px; margin-bottom: 6px;">
                                    <div class="zrx-slider-product-image" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-image: url('https://cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-1086005836_450x.jpg?v=1575978620'); background-size: cover; background-position: center; border-radius: 4px;"></div>
                                </div>
                            </div>
                            <div class="zrx-slider-product-details-div">
                                <a class="zrx-slider-product-name" style="display: block; font-size: 9px; font-weight: 500; color: #333; text-decoration: none; margin-bottom: 3px; line-height: 1.2; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: center;">Bigsweety New Fashion Women Boho</a>
                                <div class="zrx-slider-item-price">
                                    <span class="zrx-slider-product-price-wrapper" style="display: flex; justify-content: center; gap: 4px; margin-bottom: 6px;">
                                        <span class="zrx-slider-product-price zrx-compare" style="color: #999; text-decoration: line-through; font-size: 9px;">$11.66</span>
                                        <span class="zrx-slider-product-price zrx-regular" style="color: #008060; font-weight: 600; font-size: 9px;">$10.49</span>
                                    </span>
                                </div>
                                <div class="zrx-slider-variants-wrapper">
                                    <button class="zrx-slider-add-to-cart-button" style="width: 100%; background: #008060; color: white; border: none; padding: 6px; border-radius: 4px; font-size: 10px; cursor: pointer; font-weight: 500;">Add to cart</button>
                                </div>
                            </div>
                        </li>
                        <li class="zrx-slider-list-item" style="flex: 1; min-width: 0;">
                            <div class="zrx-slider-product-image-div-warpper">
                                <div class="zrx-slider-product-image-div" style="width: 100%; padding-bottom: 70%; position: relative; background: #f5f5f5; border-radius: 4px; margin-bottom: 6px;">
                                    <div class="zrx-slider-product-image" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-image: url('https://cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-1200871782_450x.jpg?v=1575968231'); background-size: cover; background-position: center; border-radius: 4px;"></div>
                                </div>
                            </div>
                            <div class="zrx-slider-product-details-div">
                                <a class="zrx-slider-product-name" style="display: block; font-size: 9px; font-weight: 500; color: #333; text-decoration: none; margin-bottom: 3px; line-height: 1.2; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: center;">Summer Slippers</a>
                                <div class="zrx-slider-item-price">
                                    <span class="zrx-slider-product-price-wrapper" style="display: flex; justify-content: center; gap: 4px; margin-bottom: 6px;">
                                        <span class="zrx-slider-product-price zrx-compare" style="color: #999; text-decoration: line-through; font-size: 9px;">$9.00</span>
                                        <span class="zrx-slider-product-price zrx-regular" style="color: #008060; font-weight: 600; font-size: 9px;">$8.10</span>
                                    </span>
                                </div>
                                <div class="zrx-slider-variants-wrapper">
                                    <button class="zrx-slider-add-to-cart-button" style="width: 100%; background: #008060; color: white; border: none; padding: 6px; border-radius: 4px; font-size: 10px; cursor: pointer; font-weight: 500;">Add to cart</button>
                                </div>
                            </div>
                        </li>
                        <li class="zrx-slider-list-item" style="flex: 1; min-width: 0;">
                            <div class="zrx-slider-product-image-div-warpper">
                                <div class="zrx-slider-product-image-div" style="width: 100%; padding-bottom: 70%; position: relative; background: #f5f5f5; border-radius: 4px; margin-bottom: 6px;">
                                    <div class="zrx-slider-product-image" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-image: url('https://cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-980699331_450x.jpg?v=1575978295'); background-size: cover; background-position: center; border-radius: 4px;"></div>
                                </div>
                            </div>
                            <div class="zrx-slider-product-details-div">
                                <a class="zrx-slider-product-name" style="display: block; font-size: 9px; font-weight: 500; color: #333; text-decoration: none; margin-bottom: 3px; line-height: 1.2; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: center;">Women Dress</a>
                                <div class="zrx-slider-item-price">
                                    <span class="zrx-slider-product-price-wrapper" style="display: flex; justify-content: center; gap: 4px; margin-bottom: 6px;">
                                        <span class="zrx-slider-product-price zrx-compare" style="color: #999; text-decoration: line-through; font-size: 9px;">$15.20</span>
                                        <span class="zrx-slider-product-price zrx-regular" style="color: #008060; font-weight: 600; font-size: 9px;">$13.68</span>
                                    </span>
                                </div>
                                <div class="zrx-slider-variants-wrapper">
                                    <button class="zrx-slider-add-to-cart-button" style="width: 100%; background: #008060; color: white; border: none; padding: 6px; border-radius: 4px; font-size: 10px; cursor: pointer; font-weight: 500;">Add to cart</button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>`,
    volume_discount: `<div class="zrx-vd-item" style="max-width: 100%; padding: 0; font-family: 'Montserrat', sans-serif;">
                <div class="zrx-vd-titles-wrapper" style="margin-bottom: 8px;">
                    <div class="zrx-vd-title" style="font-size: 14px; color: #333; font-weight: 600; text-align: center;">Buy More & Save 💰</div>
                </div>
                <div class="zrx-vd-tier-wrapper" style="margin: 0;">
                    <div class="zrx-vd-tier zrx-vd-tier-selected" style="cursor: pointer; position: relative; margin: 1px 0; border: 1px solidrgb(128, 118, 118); background-color: #f8f9fa; border-radius: 4px;">
                        <div class="zrx-vd-tier-product-details-wrapper" style="padding: 8px 8px 0; border-radius: 4px; border: 1px solidrgb(195, 195, 195); position: relative;">
                            <span class="zrx-vd-save-per-tier" style="position: absolute; right: 2px; top: -4px; height: 16px; background-color: #008060; color: #fff; border-radius: 7px; min-width: 80px; justify-content: center; font-size: 9px; border: 1px solid #fff; align-items: center; margin: 0; padding: 6px; display: flex;">
                                <span class="zrx-vd-save-per-tier-money" style="font-weight: bold;">Save 10%</span>
                            </span>
                            <div class="zrx-vd-tier-product-details" style="display: flex; align-items: center; min-height: 60px; flex-wrap: wrap; margin-top: 7px;">
                                <span class="zrx-vd-radio-btn" style="margin-right: 8px;">
                                    <input type="radio" name="radio-group" class="zrxchecked" style="position: absolute; appearance: none; visibility: hidden;">
                                    <label style="position: relative; padding-left: 28px; cursor: pointer; display: inline; color: #666;"></label>
                                </span>
                                <span class="zrx-vd-tier-product-title zrx-vd-use-dynamic-title" style="margin-right: 7px; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; margin-left: 8px; font-size: 11px;">Buy 2, Save 10.0%</span>
                                <div class="zrx-vd-tier-price-wrapper" style="display: flex; flex-direction: column; width: 100%; gap: 4px; padding: 4px 0 4px 5px; border-top: 1px solid #ededed; margin-top: 8px;">
                                    <span class="zrx-vd-tier-each-item-wrapper" style="text-align: center; line-height: 11px; font-size: 10px; min-width: 60px; display: flex; justify-content: space-between;">
                                        <span class="zrx-vd-tier-each-item-text" style="margin-right: 5px; color: #333; font-size: 10px;">Each item: </span>
                                        <span style="display: flex; align-items: center;">
                                            <span class="zrx-vd-tier-each-item-price-before-discount" style="text-decoration: line-through; margin-right: 4px; color: #999; display: inline-block; font-size: 9px; opacity: .4;">$25.46</span>
                                            <span class="zrx-vd-tier-each-item-price" style="margin-right: 5px; font-weight: 600; color: #008060; font-size: 10px;">$22.91</span>
                                        </span>
                                    </span>
                                    <div class="zrx-vd-tier-total-wrapper" style="text-align: center; line-height: 11px; font-size: 10px; min-width: 60px; display: flex; justify-content: space-between;">
                                        <span class="zrx-vd-total-text" style="margin-right: 5px; color: #333; font-size: 10px;"> Total: </span>
                                        <span class="zrx-vd-tier-total-inner" style="display: flex; align-items: center;">
                                            <span class="zrx-vd-tier-total-before-discount" style="text-decoration: line-through; margin-right: 4px; color: #999; display: inline-block; font-size: 9px; opacity: .4;">$50.92</span>
                                            <span class="zrx-vd-total-after-discount" style="margin-right: 5px; font-weight: 600; color: #008060; font-size: 10px;">$45.83</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="zrx-vd-variants-wrapper" style="width: calc(100% - 10px); margin: 0 auto;">
                            <div class="zrx-vd-variants-inner-wrapper" style="border-top: 1px solid #ededed;">
                                <div class="zrx-vd-variant-selection-wrapper" style="display: flex; justify-content: center; border-bottom: 1px solid #ededed; padding: 4px 8px; margin-top: -1px; margin-left: -1px;">
                                    <div class="zrx-vd-variant-selection" style="display: flex; align-items: center; width: 100%; max-height: 22px;">
                                        <span class="zrx-vd-variant-selection-details" style="display: flex; align-items: center; width: 100%;">
                                            <img src="https://cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-1188007936.jpg?v=1575978326" alt="" width="18px" style="margin-right: 7px; width: 18px; border-radius: 3px;">
                                            <select class="zrx-vd-variant-select" style="border-radius: 5px; outline: none; border-color: #cecece; display: inline-block; width: 100%; font-size: 10px; padding: 0 6px; height: 20px;">
                                                <option index="0" value="31141756895291"> Pink / M </option>
                                                <option index="1" value="31141757026363"> Pink / S </option>
                                                <option index="2" value="31141757124667"> Pink / XL </option>
                                            </select>
                                        </span>
                                    </div>
                                </div>
                                <div class="zrx-vd-variant-selection-wrapper" style="display: flex; justify-content: center; border-bottom: 1px solid #ededed; padding: 4px 8px; margin-top: -1px; margin-left: -1px;">
                                    <div class="zrx-vd-variant-selection" style="display: flex; align-items: center; width: 100%; max-height: 22px;">
                                        <span class="zrx-vd-variant-selection-details" style="display: flex; align-items: center; width: 100%;">
                                            <img src="https://cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-1188007936.jpg?v=1575978326" alt="" width="18px" style="margin-right: 7px; width: 18px; border-radius: 3px;">
                                            <select class="zrx-vd-variant-select" style="border-radius: 5px; outline: none; border-color: #cecece; display: inline-block; width: 100%; font-size: 10px; padding: 0 6px; height: 20px;">
                                                <option index="0" value="31141756895291"> Pink / M </option>
                                                <option index="1" value="31141757026363"> Pink / S </option>
                                                <option index="2" value="31141757124667"> Pink / XL </option>
                                            </select>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="zrx-vd-tier-wrapper" style="margin: 0;">
                        <div class="zrx-vd-tier" style="cursor: pointer; position: relative; margin: 1px 0; border: none; border-radius: 0;">
                            <div class="zrx-vd-tier-product-details-wrapper" style="padding: 8px 8px 0; border-radius: 4px; border: 1px solidrgb(195, 195, 195); position: relative;">
                                <span class="zrx-vd-most-popular-wrapper" style="position: absolute; top: -4px; left: 7px; z-index: 1;">
                                    <span class="zrx-vd-banner-pop-value zrx-vd-most-popular" style="font-size: 7px; font-weight: 600; border-radius: 5px; text-transform: uppercase; width: auto; min-width: 70px; padding: 0 6px; text-align: center; display: flex; justify-content: center; align-items: center; color: #fff; background-color: #008060; padding: 1px 0;">Most popular</span>
                                </span>
                                <span class="zrx-vd-save-per-tier" style="position: absolute; right: 2px; top: -4px; height: 16px; background-color: #008060; color: #fff; border-radius: 7px; min-width: 80px; justify-content: center; font-size: 9px; border: 1px solid #fff; align-items: center; margin: 0; padding: 6px; display: flex;">
                                    <span class="zrx-vd-save-per-tier-money" style="font-weight: bold;">Save 20%</span>
                                </span>
                                <div class="zrx-vd-tier-product-details" style="display: flex; align-items: center; min-height: 60px; flex-wrap: wrap; margin-top: 7px;">
                                    <span class="zrx-vd-radio-btn" style="margin-right: 8px;">
                                        <input type="radio" name="radio-group" class="" style="position: absolute; appearance: none; visibility: hidden;">
                                        <label style="position: relative; padding-left: 28px; cursor: pointer; display: inline; color: #666;"></label>
                                    </span>
                                    <span class="zrx-vd-tier-product-title zrx-vd-use-dynamic-title" style="margin-right: 7px; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; margin-left: 8px; font-size: 11px;">Buy 3, Save 20.0%</span>
                                    <div class="zrx-vd-tier-price-wrapper" style="display: flex; flex-direction: column; width: 100%; gap: 4px; padding: 4px 0 4px 5px; border-top: 1px solid #ededed; margin-top: 8px;">
                                        <span class="zrx-vd-tier-each-item-wrapper" style="text-align: center; line-height: 11px; font-size: 10px; min-width: 60px; display: flex; justify-content: space-between;">
                                            <span class="zrx-vd-tier-each-item-text" style="margin-right: 5px; color: #333; font-size: 10px;">Each item: </span>
                                            <span style="display: flex; align-items: center;">
                                                <span class="zrx-vd-tier-each-item-price-before-discount" style="text-decoration: line-through; margin-right: 4px; color: #999; display: inline-block; font-size: 9px; opacity: .4;">$25.46</span>
                                                <span class="zrx-vd-tier-each-item-price" style="margin-right: 5px; font-weight: 600; color: #008060; font-size: 10px;">$20.37</span>
                                            </span>
                                        </span>
                                        <div class="zrx-vd-tier-total-wrapper" style="text-align: center; line-height: 11px; font-size: 10px; min-width: 60px; display: flex; justify-content: space-between;">
                                            <span class="zrx-vd-total-text" style="margin-right: 5px; color: #333; font-size: 10px;"> Total: </span>
                                            <span class="zrx-vd-tier-total-inner" style="display: flex; align-items: center;">
                                                <span class="zrx-vd-tier-total-before-discount" style="text-decoration: line-through; margin-right: 4px; color: #999; display: inline-block; font-size: 9px; opacity: .4;">$76.38</span>
                                                <span class="zrx-vd-total-after-discount" style="margin-right: 5px; font-weight: 600; color: #008060; font-size: 10px;">$61.10</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 8px;">
                        <div class="zrx-vd-add-to-cart-button" style="border: none; outline: none; color: #fff; background-color: #008060; height: 32px; border-radius: 3px; width: 100%; position: relative; display: flex; align-items: center; justify-content: center; cursor: pointer;">
                            <span class="zrx-vd-add-to-cart-text" style="font-weight: 600; letter-spacing: .1em; font-size: 11px;">
                                <span>GET OFFER!</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>`,
    bundle: `<div class="zrx-widget-bundle">
        <div class="zrx-frequently-bought-together zrx-bundle bundle-items-3 zrx-bundle-type-fixed" style="max-width: 100%; padding: 4px;">
            <div class="zrx-bundle-title-wrapper">
                <div class="zrx-bundle-main-title" style="text-align: center; font-size: 14px; margin: 0 0 8px 0; color: #333; font-weight: 600;">Bundle & Save $20 🛒</div>
            </div>
            <div class="zrx-bundle-multi-item-container">
                <div class="zrx-bundle-multi-item-list" style="grid-template-columns: 1fr 1fr 1fr; display: grid; gap: 8px;">
                    <div data-product-id="4344276844603" class="zrx-bundle-multi-item-wrapper">
                        <div class="zrx-bundle-item-wrapper zrx-bundle-multi-item">
                            <div class="zrx-bundle-product-image-div" style="height: 80px; position: relative; background: #f5f5f5; border-radius: 4px;">
                                <div class="zrx-bundle-product-image" style="background-image: url('//cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-980699331_450x.jpg?v=1575978295'); position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-size: cover; background-position: center; border-radius: 4px;"></div>
                            </div>
                            <div class="zrx-bundle-product-details-div">
                                <div class="zrx-bundle-product-name" style="text-align: center; margin-bottom: 4px;">
                                    <a href="/products/women-dress" style="font-size: 10px; font-weight: 500; color: #333; text-decoration: none;">Women Dress</a>
                                </div>
                                <span class="zrx-bundle-item-variants-wrapper">
                                    <div class="zrx-bundle-item-variants">
                                        <select class="zrx-bundle-variant-select" style="width: 100%; font-size: 9px; padding: 2px; border: 1px solid #ddd; border-radius: 3px;">
                                            <option index="0"> Black / L </option>
                                            <option index="1"> Black / XXL </option>
                                            <option index="2"> Black / M </option>
                                            <option index="3"> Black / S </option>
                                            <option index="4"> Black / XL </option>
                                        </select>
                                    </div>
                                </span>
                                <div class="zrx-bundle-item-price" style="text-align: center; margin-top: 4px; display: flex; align-items: center; justify-content: center;">
                                    <label style="display: flex; align-items: center; margin-right: 4px;">
                                        <input type="checkbox" style="display: none;">
                                        <svg viewBox="0 0 21 21" style="width: 14px; height: 14px; border: 1px solid #ddd; border-radius: 2px; background: white;">
                                            <polyline points="5 10.75 8.5 14.25 16 6" style="stroke: #008060; stroke-width: 2; fill: none; opacity: 0;"></polyline>
                                        </svg>
                                    </label>
                                    <span class="zrx-bundle-product-item-price-wrapper" style="display: flex; align-items: center;">
                                        <span class="zrx-bundle-product-price zrx-bundle-item-price" style="color: #008060; font-weight: 600; font-size: 10px;">$15.20</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="zrx-bundle-plus-sign zrx-items-3" style="height: calc(80px); visibility: visible; display: flex; align-items: center; justify-content: center; font-size: 16px; font-weight: bold; color: #666;"> + </div>
                    </div>
                    <div data-product-id="4344276156475" class="zrx-bundle-multi-item-wrapper">
                        <div class="zrx-bundle-item-wrapper zrx-bundle-multi-item">
                            <div class="zrx-bundle-product-image-div" style="height: 80px; position: relative; background: #f5f5f5; border-radius: 4px;">
                                <div class="zrx-bundle-product-image" style="background-image: url('//cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-1086005836_450x.jpg?v=1575978620'); position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-size: cover; background-position: center; border-radius: 4px;"></div>
                            </div>
                            <div class="zrx-bundle-product-details-div">
                                <div class="zrx-bundle-product-name" style="text-align: center; margin-bottom: 4px;">
                                    <a href="/products/bigsweety-new-fashion-women-boho" style="font-size: 9px; font-weight: 500; color: #333; text-decoration: none;">Bigsweety New Fashion Women Boho</a>
                                </div>
                                <span class="zrx-bundle-item-variants-wrapper">
                                    <div class="zrx-bundle-item-variants">
                                        <select class="zrx-bundle-variant-select" style="width: 100%; font-size: 9px; padding: 2px; border: 1px solid #ddd; border-radius: 3px;">
                                            <option index="0"> striped / XL </option>
                                            <option index="1"> striped / L </option>
                                            <option index="4"> striped / M </option>
                                            <option index="5"> striped / S </option>
                                        </select>
                                    </div>
                                </span>
                                <div class="zrx-bundle-item-price" style="text-align: center; margin-top: 4px; display: flex; align-items: center; justify-content: center;">
                                    <label style="display: flex; align-items: center; margin-right: 4px;">
                                        <input type="checkbox" style="display: none;">
                                        <svg viewBox="0 0 21 21" style="width: 14px; height: 14px; border: 1px solid #ddd; border-radius: 2px; background: white;">
                                            <polyline points="5 10.75 8.5 14.25 16 6" style="stroke: #008060; stroke-width: 2; fill: none; opacity: 0;"></polyline>
                                        </svg>
                                    </label>
                                    <span class="zrx-bundle-product-item-price-wrapper" style="display: flex; align-items: center;">
                                        <span class="zrx-bundle-product-price zrx-bundle-compare" style="color: #999; text-decoration: line-through; font-size: 9px; margin-right: 4px;">$21.66</span>
                                        <span class="zrx-bundle-product-price zrx-bundle-item-price" style="color: #008060; font-weight: 600; font-size: 10px;">$11.66</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="zrx-bundle-plus-sign zrx-items-3" style="height: calc(80px); visibility: visible; display: flex; align-items: center; justify-content: center; font-size: 16px; font-weight: bold; color: #666;"> + </div>
                    </div>
                    <div data-product-id="4344277041211" class="zrx-bundle-multi-item-wrapper">
                        <div class="zrx-bundle-item-wrapper zrx-bundle-multi-item">
                            <div class="zrx-bundle-product-image-div" style="height: 80px; position: relative; background: #f5f5f5; border-radius: 4px;">
                                <div class="zrx-bundle-product-image" style="background-image: url('//cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-1163052565_450x.jpg?v=1575978294'); position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-size: cover; background-position: center; border-radius: 4px;"></div>
                            </div>
                            <div class="zrx-bundle-product-details-div">
                                <div class="zrx-bundle-product-name" style="text-align: center; margin-bottom: 4px;">
                                    <a href="/products/neck-women-dress" style="font-size: 10px; font-weight: 500; color: #333; text-decoration: none;">Neck Women Dress</a>
                                </div>
                                <span class="zrx-bundle-item-variants-wrapper">
                                    <div class="zrx-bundle-item-variants">
                                        <select class="zrx-bundle-variant-select" style="width: 100%; font-size: 9px; padding: 2px; border: 1px solid #ddd; border-radius: 3px;">
                                            <option index="0"> White / L </option>
                                            <option index="1"> White / XL </option>
                                            <option index="2"> White / S </option>
                                            <option index="3"> White / M </option>
                                        </select>
                                    </div>
                                </span>
                                <div class="zrx-bundle-item-price" style="text-align: center; margin-top: 4px; display: flex; align-items: center; justify-content: center;">
                                    <label style="display: flex; align-items: center; margin-right: 4px;">
                                        <input type="checkbox" style="display: none;">
                                        <svg viewBox="0 0 21 21" style="width: 14px; height: 14px; border: 1px solid #ddd; border-radius: 2px; background: white;">
                                            <polyline points="5 10.75 8.5 14.25 16 6" style="stroke: #008060; stroke-width: 2; fill: none; opacity: 0;"></polyline>
                                        </svg>
                                    </label>
                                    <span class="zrx-bundle-product-item-price-wrapper" style="display: flex; align-items: center;">
                                        <span class="zrx-bundle-product-price zrx-bundle-item-price" style="color: #008060; font-weight: 600; font-size: 10px;">$9.98</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="zrx-bundle-plus-sign zrx-items-3" style="height: calc(80px); visibility: hidden; display: flex; align-items: center; justify-content: center; font-size: 16px; font-weight: bold; color: #666;"> + </div>
                    </div>
                </div>
                <div style="margin-top: 6px;">
                    <div class="zrx-bundle-summary">
                        <div class="zrx-bundle-price-wrapper" style="display: flex; align-items: center; margin-bottom: 8px;">
                            <span class="zrx-bundle-price-container">
                                <span class="zrx-bundle-total-price-text" style="color: #333; margin-right: 0;">Total Price:</span>
                                <span class="zrx-bundle-total-price-inner">
                                    <span class="zrx-bundle-seperate-price money" style="color: #333; text-decoration: line-through; font-size: 14px;">$36.84</span>
                                    <span class="zrx-bundle-price" style="color: #333; font-weight: 600; font-size: 14px;">$16.84</span>
                                </span>
                            </span>
                            <span class="zrx-bundle-save-wrapper">
                                <span class="zrx-bundle-save">
                                    <span class="zrx-bundle-save-text" style="color: #008060; font-weight: 600; font-size: 12px;">Save $20.00</span>
                                </span>
                            </span>
                        </div>
                        <div class="zrx-bundle-add-bundle-wrapper">
                            <div class="zrx-bundle-add-bundle-button zrx-popup-info-open" style="width: 100%; background: #008060; color: white; border: none; padding: 6px; border-radius: 4px; font-size: 12px; cursor: pointer; font-weight: 600; text-align: center;">
                                <span class="zrx-bundle-add-bundle-button-text">ADD BUNDLE!</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`,
    mix_and_match: `<div class="zrx-mm-ext-offer-collection-wrapper">
        <div class="zrx-mm-ext-offer-collection-container">
            <div class="zrx-mm-ext-offer-collection-separator"></div>
            <div class="zrx-mm-ext-offer-collection-inner">
                <div class="zrx-mm-ext-toggle-collection-wrapper zrx-mm-ext-mini-cart-no-items">
                    <div class="zrx-mm-ext-hide-collection">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451.847 451.847" xml:space="preserve" class="zrx-mm-ext-toggle-collection-icon">
                            <g>
                                <path d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751
		c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0
		c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"></path>
                            </g>
                        </svg>
                    </div>
                </div>
                <div class="zrx-mm-ext-offer-collection-image-wrapper"></div>
                <div class="zrx-mm-ext-offer-header">
                    <div>
                        <div class="zrx-mm-ext-collection-title"></div>
                        <span class="zrx-mm-ext-offer-add-items-from-collection">Buy 3 Dresses, Enjoy 50% Off 🥰</span>
                    </div>
                </div>
            </div>
            <div class="zrx-mm-ext-offer-collection-separator"></div>
        </div>
        <div class="zrx-mm-ext-offer-separator"></div>
        <div class="zrx-mm-ext-items-expanded-container">
            <div class="zrx-mm-ext-searchable-items-wrapper">
                <div class="zrx-mm-ext-searchable-item">
                    <div alt="" class="zrx-mm-ext-searchable-item-image" style="background-image: url('https://cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-1185217091_450x.jpg?v=1575968204');"></div>
                    <div class="zrx-mm-ext-searchable-item-name-price-wrapper">
                        <span class="zrx-mm-qty-modifier-wrapper">
                            <span class="zrx-mm-qty-modifier-inner">
                                <span class="zrx-mm-qty-modifier-minus zrx-mm-qty-modifier-enable">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 2" class="icon icon-minus">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                                    </svg>
                                </span>
                                <input class="zrx-mm-qty-modifier-input">
                                <span class="zrx-mm-qty-modifier-plus zrx-mm-qty-modifier-enable">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 10" class="icon icon-plus">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                                    </svg>
                                </span>
                            </span>
                        </span>
                        <div class="zrx-mm-ext-searchable-item-name">Summer Water Shoes</div>
                        <div class="zrx-mm-ext-searchable-item-prices-wrapper">
                            <div class="zrx-mm-ext-searchable-item-compare-to-price" style="display: none;">$29.16</div>
                            <div class="zrx-mm-ext-searchable-item-price">$29.16</div>
                        </div>
                    </div>
                    <div class="zrx-mm-ext-searchable-item-select-button-wrapper">
                        <div class="zrx-mm-ext-searchable-item-option-group">
                            <div class="zrx-mm-ext-searchable-item-option-wrapper">
                                <div class="zrx-mm-ext-searchable-item-option-name">Color</div>
                                <div class="zrx-mm-ext-searchable-item-select-wrapper">
                                    <select class="zrx-mm-ext-searchable-item-select">
                                        <option value="Black"> Black </option>
                                        <option value="Black-red"> Black-red </option>
                                        <option value="Grey-yellow"> Grey-yellow </option>
                                        <option value="Blue"> Blue </option>
                                        <option value="White"> White </option>
                                    </select>
                                </div>
                            </div>
                            <div class="zrx-mm-ext-searchable-item-option-wrapper">
                                <div class="zrx-mm-ext-searchable-item-option-name">Shoe Size</div>
                                <div class="zrx-mm-ext-searchable-item-select-wrapper">
                                    <select class="zrx-mm-ext-searchable-item-select">
                                        <option value="37"> 37 </option>
                                        <option value="38"> 38 </option>
                                        <option value="39"> 39 </option>
                                        <option value="40"> 40 </option>
                                        <option value="36"> 36 </option>
                                        <option value="45"> 45 </option>
                                        <option value="46"> 46 </option>
                                        <option value="41"> 41 </option>
                                        <option value="42"> 42 </option>
                                        <option value="43"> 43 </option>
                                        <option value="44"> 44 </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="zrx-mm-ext-searchable-item-atc-button">
                            <span class="zrx-mm-ext-searchable-item-atc-button-text">Add</span>
                        </div>
                    </div>
                </div>
                <div class="zrx-mm-ext-searchable-item">
                    <div alt="" class="zrx-mm-ext-searchable-item-image" style="background-image: url('https://cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-1200871790_450x.jpg?v=1575968231');"></div>
                    <div class="zrx-mm-ext-searchable-item-name-price-wrapper">
                        <span class="zrx-mm-qty-modifier-wrapper">
                            <span class="zrx-mm-qty-modifier-inner">
                                <span class="zrx-mm-qty-modifier-minus zrx-mm-qty-modifier-enable">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 2" class="icon icon-minus">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                                    </svg>
                                </span>
                                <input class="zrx-mm-qty-modifier-input">
                                <span class="zrx-mm-qty-modifier-plus zrx-mm-qty-modifier-enable">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 10" class="icon icon-plus">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                                    </svg>
                                </span>
                            </span>
                        </span>
                        <div class="zrx-mm-ext-searchable-item-name">Summer Slippers</div>
                        <div class="zrx-mm-ext-searchable-item-prices-wrapper">
                            <div class="zrx-mm-ext-searchable-item-compare-to-price">$19.00</div>
                            <div class="zrx-mm-ext-searchable-item-price">$9.00</div>
                        </div>
                    </div>
                    <div class="zrx-mm-ext-searchable-item-select-button-wrapper">
                        <div class="zrx-mm-ext-searchable-item-option-group">
                            <div class="zrx-mm-ext-searchable-item-option-wrapper">
                                <div class="zrx-mm-ext-searchable-item-option-name">Color</div>
                                <div class="zrx-mm-ext-searchable-item-select-wrapper">
                                    <select class="zrx-mm-ext-searchable-item-select">
                                        <option value="Blue"> Blue </option>
                                        <option value="Gray"> Gray </option>
                                        <option value="Light purple"> Light purple </option>
                                        <option value="Light blue"> Light blue </option>
                                        <option value="Pink"> Pink </option>
                                    </select>
                                </div>
                            </div>
                            <div class="zrx-mm-ext-searchable-item-option-wrapper">
                                <div class="zrx-mm-ext-searchable-item-option-name">Shoe Size</div>
                                <div class="zrx-mm-ext-searchable-item-select-wrapper">
                                    <select class="zrx-mm-ext-searchable-item-select">
                                        <option value="43"> 43 </option>
                                        <option value="41"> 41 </option>
                                        <option value="39"> 39 </option>
                                        <option value="37"> 37 </option>
                                        <option value="45"> 45 </option>
                                        <option value="36"> 36 </option>
                                        <option value="38"> 38 </option>
                                        <option value="40"> 40 </option>
                                        <option value="42"> 42 </option>
                                        <option value="44"> 44 </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="zrx-mm-ext-searchable-item-atc-button">
                            <span class="zrx-mm-ext-searchable-item-atc-button-text">Add</span>
                        </div>
                    </div>
                </div>
                <div class="zrx-mm-ext-searchable-item">
                    <div alt="" class="zrx-mm-ext-searchable-item-image" style="background-image: url('https://cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-1123714492_450x.jpg?v=1575968240');"></div>
                    <div class="zrx-mm-ext-searchable-item-name-price-wrapper">
                        <span class="zrx-mm-qty-modifier-wrapper">
                            <span class="zrx-mm-qty-modifier-inner">
                                <span class="zrx-mm-qty-modifier-minus zrx-mm-qty-modifier-enable">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 2" class="icon icon-minus">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                                    </svg>
                                </span>
                                <input class="zrx-mm-qty-modifier-input">
                                <span class="zrx-mm-qty-modifier-plus zrx-mm-qty-modifier-enable">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 10" class="icon icon-plus">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                                    </svg>
                                </span>
                            </span>
                        </span>
                        <div class="zrx-mm-ext-searchable-item-name">OZERSK Men Sneakers</div>
                        <div class="zrx-mm-ext-searchable-item-prices-wrapper">
                            <div class="zrx-mm-ext-searchable-item-compare-to-price" style="display: none;">$34.22</div>
                            <div class="zrx-mm-ext-searchable-item-price">$34.22</div>
                        </div>
                    </div>
                    <div class="zrx-mm-ext-searchable-item-select-button-wrapper">
                        <div class="zrx-mm-ext-searchable-item-option-group">
                            <div class="zrx-mm-ext-searchable-item-option-wrapper">
                                <div class="zrx-mm-ext-searchable-item-option-name">Color</div>
                                <div class="zrx-mm-ext-searchable-item-select-wrapper">
                                    <select class="zrx-mm-ext-searchable-item-select">
                                        <option value="01 Black"> 01 Black </option>
                                        <option value="01 Blue"> 01 Blue </option>
                                        <option value="04 Black"> 04 Black </option>
                                        <option value="01 White"> 01 White </option>
                                        <option value="03 Fur Blue"> 03 Fur Blue </option>
                                        <option value="03 Fur Black"> 03 Fur Black </option>
                                        <option value="04 Gray"> 04 Gray </option>
                                        <option value="04 Blue"> 04 Blue </option>
                                        <option value="03 Blue"> 03 Blue </option>
                                        <option value="03 Black"> 03 Black </option>
                                        <option value="03 Fur Gray"> 03 Fur Gray </option>
                                        <option value="02 Black"> 02 Black </option>
                                        <option value="03 Gray"> 03 Gray </option>
                                    </select>
                                </div>
                            </div>
                            <div class="zrx-mm-ext-searchable-item-option-wrapper">
                                <div class="zrx-mm-ext-searchable-item-option-name">Shoe Size</div>
                                <div class="zrx-mm-ext-searchable-item-select-wrapper">
                                    <select class="zrx-mm-ext-searchable-item-select">
                                        <option value="8"> 8 </option>
                                        <option value="8.5"> 8.5 </option>
                                        <option value="7"> 7 </option>
                                        <option value="7.5"> 7.5 </option>
                                        <option value="11"> 11 </option>
                                        <option value="6.5"> 6.5 </option>
                                        <option value="9.5"> 9.5 </option>
                                        <option value="10"> 10 </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="zrx-mm-ext-searchable-item-atc-button">
                            <span class="zrx-mm-ext-searchable-item-atc-button-text">Add</span>
                        </div>
                    </div>
                </div>
                <div class="zrx-mm-ext-searchable-item">
                    <div alt="" class="zrx-mm-ext-searchable-item-image" style="background-image: url('https://cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-1086005814_450x.jpg?v=1575978620');"></div>
                    <div class="zrx-mm-ext-searchable-item-name-price-wrapper">
                        <span class="zrx-mm-qty-modifier-wrapper">
                            <span class="zrx-mm-qty-modifier-inner">
                                <span class="zrx-mm-qty-modifier-minus zrx-mm-qty-modifier-enable">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 2" class="icon icon-minus">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                                    </svg>
                                </span>
                                <input class="zrx-mm-qty-modifier-input">
                                <span class="zrx-mm-qty-modifier-plus zrx-mm-qty-modifier-enable">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 10" class="icon icon-plus">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                                    </svg>
                                </span>
                            </span>
                        </span>
                        <div class="zrx-mm-ext-searchable-item-name">Bigsweety New Fashion Women Boho</div>
                        <div class="zrx-mm-ext-searchable-item-prices-wrapper">
                            <div class="zrx-mm-ext-searchable-item-compare-to-price">$21.66</div>
                            <div class="zrx-mm-ext-searchable-item-price">$11.66</div>
                        </div>
                    </div>
                    <div class="zrx-mm-ext-searchable-item-select-button-wrapper">
                        <div class="zrx-mm-ext-searchable-item-option-group">
                            <div class="zrx-mm-ext-searchable-item-option-wrapper">
                                <div class="zrx-mm-ext-searchable-item-option-name">Color</div>
                                <div class="zrx-mm-ext-searchable-item-select-wrapper">
                                    <select class="zrx-mm-ext-searchable-item-select">
                                        <option value="striped"> striped </option>
                                        <option value="wine red"> wine red </option>
                                        <option value="navy blue"> navy blue </option>
                                        <option value="black"> black </option>
                                        <option value="purple"> purple </option>
                                        <option value="apricot"> apricot </option>
                                        <option value="white"> white </option>
                                        <option value="black 2"> black 2 </option>
                                        <option value="wine red 2"> wine red 2 </option>
                                        <option value="khaki"> khaki </option>
                                        <option value="navy blue 2"> navy blue 2 </option>
                                        <option value="green"> green </option>
                                        <option value="red"> red </option>
                                        <option value="black 3"> black 3 </option>
                                        <option value="deep blue"> deep blue </option>
                                        <option value="light blue"> light blue </option>
                                    </select>
                                </div>
                            </div>
                            <div class="zrx-mm-ext-searchable-item-option-wrapper">
                                <div class="zrx-mm-ext-searchable-item-option-name">Size</div>
                                <div class="zrx-mm-ext-searchable-item-select-wrapper">
                                    <select class="zrx-mm-ext-searchable-item-select">
                                        <option value="XL"> XL </option>
                                        <option value="L"> L </option>
                                        <option value="S"> S </option>
                                        <option value="XXL"> XXL </option>
                                        <option value="M"> M </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="zrx-mm-ext-searchable-item-atc-button">
                            <span class="zrx-mm-ext-searchable-item-atc-button-text">Add</span>
                        </div>
                    </div>
                </div>
                <div class="zrx-mm-ext-searchable-item">
                    <div alt="" class="zrx-mm-ext-searchable-item-image" style="background-image: url('https://cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-1207749900_450x.jpg?v=1575978319');"></div>
                    <div class="zrx-mm-ext-searchable-item-name-price-wrapper">
                        <span class="zrx-mm-qty-modifier-wrapper">
                            <span class="zrx-mm-qty-modifier-inner">
                                <span class="zrx-mm-qty-modifier-minus zrx-mm-qty-modifier-enable">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 2" class="icon icon-minus">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                                    </svg>
                                </span>
                                <input class="zrx-mm-qty-modifier-input">
                                <span class="zrx-mm-qty-modifier-plus zrx-mm-qty-modifier-enable">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 10" class="icon icon-plus">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                                    </svg>
                                </span>
                            </span>
                        </span>
                        <div class="zrx-mm-ext-searchable-item-name">Boho Dress</div>
                        <div class="zrx-mm-ext-searchable-item-prices-wrapper">
                            <div class="zrx-mm-ext-searchable-item-compare-to-price" style="display: none;">$33.48</div>
                            <div class="zrx-mm-ext-searchable-item-price">$33.48</div>
                        </div>
                    </div>
                    <div class="zrx-mm-ext-searchable-item-select-button-wrapper">
                        <div class="zrx-mm-ext-searchable-item-option-group">
                            <div class="zrx-mm-ext-searchable-item-option-wrapper">
                                <div class="zrx-mm-ext-searchable-item-option-name">Color</div>
                                <div class="zrx-mm-ext-searchable-item-select-wrapper">
                                    <select class="zrx-mm-ext-searchable-item-select">
                                        <option value="1"> 1 </option>
                                        <option value="2"> 2 </option>
                                    </select>
                                </div>
                            </div>
                            <div class="zrx-mm-ext-searchable-item-option-wrapper">
                                <div class="zrx-mm-ext-searchable-item-option-name">Size</div>
                                <div class="zrx-mm-ext-searchable-item-select-wrapper">
                                    <select class="zrx-mm-ext-searchable-item-select">
                                        <option value="S"> S </option>
                                        <option value="XL"> XL </option>
                                        <option value="M"> M </option>
                                        <option value="L"> L </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="zrx-mm-ext-searchable-item-atc-button">
                            <span class="zrx-mm-ext-searchable-item-atc-button-text">Add</span>
                        </div>
                    </div>
                </div>
                <div class="zrx-mm-ext-searchable-item">
                    <div alt="" class="zrx-mm-ext-searchable-item-image" style="background-image: url('https://cdn.shopify.com/s/files/1/0259/7296/5435/products/product-image-1204725586_450x.jpg?v=1575978319');"></div>
                    <div class="zrx-mm-ext-searchable-item-name-price-wrapper">
                        <span class="zrx-mm-qty-modifier-wrapper">
                            <span class="zrx-mm-qty-modifier-inner">
                                <span class="zrx-mm-qty-modifier-minus zrx-mm-qty-modifier-enable">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 2" class="icon icon-minus">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                                    </svg>
                                </span>
                                <input class="zrx-mm-qty-modifier-input">
                                <span class="zrx-mm-qty-modifier-plus zrx-mm-qty-modifier-enable">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 10" class="icon icon-plus">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                                    </svg>
                                </span>
                            </span>
                        </span>
                        <div class="zrx-mm-ext-searchable-item-name">Summer Ruffles Dress Boho Beach</div>
                        <div class="zrx-mm-ext-searchable-item-prices-wrapper">
                            <div class="zrx-mm-ext-searchable-item-compare-to-price" style="display: none;">$19.56</div>
                            <div class="zrx-mm-ext-searchable-item-price">$19.56</div>
                        </div>
                    </div>
                    <div class="zrx-mm-ext-searchable-item-select-button-wrapper">
                        <div class="zrx-mm-ext-searchable-item-option-group">
                            <div class="zrx-mm-ext-searchable-item-option-wrapper">
                                <div class="zrx-mm-ext-searchable-item-option-name">Color</div>
                                <div class="zrx-mm-ext-searchable-item-select-wrapper">
                                    <select class="zrx-mm-ext-searchable-item-select">
                                        <option value="Green"> Green </option>
                                        <option value="Navy Blue"> Navy Blue </option>
                                    </select>
                                </div>
                            </div>
                            <div class="zrx-mm-ext-searchable-item-option-wrapper">
                                <div class="zrx-mm-ext-searchable-item-option-name">Size</div>
                                <div class="zrx-mm-ext-searchable-item-select-wrapper">
                                    <select class="zrx-mm-ext-searchable-item-select">
                                        <option value="XXL"> XXL </option>
                                        <option value="XL"> XL </option>
                                        <option value="L"> L </option>
                                        <option value="M"> M </option>
                                        <option value="S"> S </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="zrx-mm-ext-searchable-item-atc-button">
                            <span class="zrx-mm-ext-searchable-item-atc-button-text">Add</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
}

export const videoModal = (title, modalOpenBool, toggleFunc, poster, source ) => {
   let player = {};
   return  <AntModal visible={modalOpenBool}
                   onCancel={(() => {
                        player.pause();
                        toggleFunc();
                    })}
                   title={title}
                   cancelText={'Close'}
                   okText="Select"
                   className="video-modal"
                   footer={null}
                   width="900px"
            >

                 <Player
                    ref={p => {
                        player = p;
                    }}
                    poster={poster}
                    src={source}
                    playsInline
                    aspectRatio="auto"
                    ><BigPlayButton position="center" />
                </Player>
        </AntModal>
}

const previewImageComponent = (currentOfferType) =>
    <div className='offer-image-preview' dangerouslySetInnerHTML={{ __html: htmlPerOfferType[currentOfferType] }}>
    </div>

const offerTypeComponent = (currentOfferType, offerType, selectOfferType, mainBlock, innerBlock, toggleVideoModal) =>
    <div className={currentOfferType === offerType ? 'offer-type-block selected' : 'offer-type-block not-selected'}
         onClick={selectOfferType(offerType)}>
        <span className={'checkbox'}>
            <div className={'container'}>
                <div className={'round'}>
                    <input type="checkbox" readOnly checked={currentOfferType === offerType} id={offerType}/>
                    <label htmlFor={offerType}></label>
                </div>
            </div>
        </span>
        <div className='blocks-video-wrapper'>
            <div className='blocks-wrapper'>
                <div className={'main-block'}>{mainBlock}</div>
                <div className={'inner-block'}>{innerBlock}</div>
            </div>
          {toggleVideoModal && <div className='video-block' onClick={toggleVideoModal}>
                    <Icon source={PlayCircleMajor} color="base"/>
            </div>}
        </div>
    </div>;

/*const bundleOffer = (currentOfferType, currentBundleType, bundleType, selectBundleType, block) =>
    <div className={'bundle-offer-type'}>
         <span className={'checkbox'}>
                <div className={'container'}>
                    <div className={'round'}>
                        <input type="checkbox" readOnly checked={currentBundleType === bundleType} id={bundleType}/>
                        <label htmlFor={bundleType}></label>
                    </div>
                </div>
            </span>
        <div className={currentOfferType === 'bundle' && currentBundleType === bundleType ? 'selected' : 'not-selected'}
             onClick={selectBundleType(bundleType)}>
            <div className={'sub-offer-type'}>{block}</div>
        </div>
    </div>*/

const AppV2WizardSelectOfferType = ({
    appV2Wizard, selectOfferType, selectBundleType, back, next, toggleContactUsModal,
    sendSupportRequest, data, support, onNameChange, onEmailChanged, onTextChanged, status,
    toggleCrossSellVideoModal, toggleBundleVideoModal, toggleVolumeDiscountVideoModal, toggleMixAndMatchVideoModal
}) => {
    // Add useEffect to scroll down offer-image-preview content after page load
    useEffect(() => {
        const scrollPreviewContent = () => {
            const previewElements = document.querySelectorAll('.offer-image-preview');
            previewElements.forEach(element => {
                // Skip volume discount as it doesn't need scrolling
                const offerType = element.closest('.offer-type-block');
                if (offerType && offerType.querySelector('.title')?.textContent === 'Volume Discount') {
                    return;
                }
                
                if (element.scrollHeight > element.clientHeight) {
                    // Smooth scroll to bottom after a short delay with custom slow animation
                    setTimeout(() => {
                        const startPosition = element.scrollTop;
                        const targetPosition = element.scrollHeight - element.clientHeight;
                        const distance = targetPosition - startPosition;
                        const duration = 2000; // 2 seconds (2x faster than before)
                        const startTime = performance.now();
                        
                        const animateScroll = (currentTime) => {
                            const elapsed = currentTime - startTime;
                            const progress = Math.min(elapsed / duration, 1);
                            
                            // Easing function for smooth animation
                            const easeInOutQuad = progress < 0.5 
                                ? 2 * progress * progress 
                                : 1 - Math.pow(-2 * progress + 2, 2) / 2;
                            
                            element.scrollTop = startPosition + (distance * easeInOutQuad);
                            
                            if (progress < 1) {
                                requestAnimationFrame(animateScroll);
                            }
                        };
                        
                        requestAnimationFrame(animateScroll);
                    }, 2000);
                }
            });
        };

        // Execute after component mounts and content is rendered
        scrollPreviewContent();
    }, []);

    return (
    <div className={'app-v2-wizard-select-offer-type'}>
        <VisibleSendEvent stateToEventFunc={() => ({event: 'onboarding_wizard_select_offer_type_shown', props: {}})} />
        <div className={'app-v2-wizard-select-offer-type-content'}>
            <div>
            {/* <div className='select-offer-type-header'>
                <div className='select-offer-type-title-wrapper'>
                    <div className={'select-offer-type-title'}>Select offer type</div>
                    <div className={'select-offer-type-subtitle'}>Select the type of offer to show your customers</div>
                </div>
                <div className={'upper-nav-buttons-wrapper'}>
                    <div onClick={next} className={'app-v2-wizard-next-btn app-v2-wizard-upper-next-btn'}>Next</div>
                </div>
            </div> */}
            </div>
            <div className='select-offer-type-offers-help-wrapper'>
            <div className={'offers'}>
                {offerTypeComponent(appV2Wizard.offerType, 'cross_sell', selectOfferType, <div className={'offer-type'}>
                        <div className={'title'}>Cross Sell</div>
                            <div className={'preview-container'}>
                                {previewImageComponent('cross_sell')}
                                <div className={'hover-content'}>
                                    <div className={'description'}>Offer complementary products which bought together with the main product</div>
                                    <div className={'example'}>Example - Offer <span className={'strong'}>products X, Y, Z</span> for&nbsp;
                        <span className={'strong'}>product A</span>
                                    </div>
                                </div>
                            </div>
                    </div>,
                        null,
                    toggleCrossSellVideoModal
                )}
                {offerTypeComponent(appV2Wizard.offerType, 'volume_discount', selectOfferType, <div>
                            <div className={'title'}>Volume Discount</div>
                            <div className={'preview-container'}>
                                {previewImageComponent('volume_discount')}
                                <div className={'hover-content'}>
                                    <div className={'description'}>Offer discount based on number of purchased items</div>
                                    <div className={'example'}>Example - Buy X pieces of <span className="strong">Product A</span> and get&nbsp;
                                        <span className="strong">20% off</span></div>
                                </div>
                            </div>
                    </div>,
                        null,
                        toggleVolumeDiscountVideoModal
                )}
                {offerTypeComponent(appV2Wizard.offerType, 'bundle', selectOfferType, <div>
                        <div className={'title'}>Bundle</div>
                            <div className={'preview-container'}>
                                {previewImageComponent('bundle')}
                                <div className={'hover-content'}>
                                    <div className={'description'}>Offer discount when certain products are bought together</div>
                                    <div className={'example'}>Example - Buy <span className="strong">Products A, B & C</span> together and get&nbsp;
                                        <span className="strong">20% off</span></div>
                                </div>
                            </div>
                    </div>,
                        null,
                    toggleBundleVideoModal
                )}
                {/*{offerTypeComponent(appV2Wizard.offerType, 'bogo', selectOfferType, <div>*/}
                {/*        <div className={'title'}>BOGO</div>*/}
                {/*        <div>TBD</div>*/}
                {/*    </div>,*/}
                {/*    <div>Example - Buy <span className="strong">Products A, B & C</span> together and get&nbsp;*/}
                {/*        <span className="strong">Products D, E, F at 20% off</span></div>,*/}
                {/*    null,*/}
                {/*)}*/}
                {status.appEmbeds && offerTypeComponent(appV2Wizard.offerType, 'mix_and_match', selectOfferType, <div>
                    <div className={'title'}>Mix & Match</div>
                        <div className={'preview-container'}>
                            {previewImageComponent('mix_and_match')}
                            <div className={'hover-content'}>
                                <div className={'description'}>Offer discount based on collections</div>
                                <div className={'example'}>Example - buy X items from <span className="strong">collection A</span> and buy Y items from <span className="strong">collection B</span> and get&nbsp;
                    <span className="strong">15% off</span>
            </div>
            </div>
            </div>
                    </div>,
                    null,
                    toggleMixAndMatchVideoModal)}
                    </div>
                </div>
                <div className="floating-buttons-wrapper">
                            <span className={'need-help-call-to-action'} onClick={toggleContactUsModal}>Contact Us</span>
                    <div onClick={next} className={'app-v2-wizard-next-btn'}>Next</div>
            </div>
        </div>
         <PModal open={appV2Wizard.contactUsModalOpen} onClose={toggleContactUsModal}
               title="Contact Us"
               primaryAction={{
                   content: 'Send',
                   onAction: sendSupportRequest,
                   loading: appV2Wizard.sendingSupportRequest,
               }}
               secondaryActions={[
                   {
                       content: 'Cancel',
                       onAction: toggleContactUsModal,
                   },
               ]}>
            <PModal.Section>
                { support.error &&
                <TextStyle variation="negative">There was an error sending your request. Please try again in a few
                    minutes</TextStyle> }
                <TextField label="Your name *" value={data.ownerName} onChange={onNameChange}/>
                <TextField type="email" label="Your email *" value={data.ownerEmail} onChange={onEmailChanged}/>
                <TextField label="How can we help? *" multiline={5} value={support.text}
                           onChange={onTextChanged} error={support.textError}/>
            </PModal.Section>
        </PModal>

        {videoModal('Cross-Sell Offer Tutorial Video',
                    appV2Wizard.crossSellVideoModalOpen,
                    toggleCrossSellVideoModal,
                   'https://public.zoorix.com/videos/onboarding_cross_sell_poster-x.webp',
                   'https://public.zoorix.com/videos/onboarding_cross_sell.mp4'
                   )}
        {videoModal('Bundle Offer Tutorial Video',
                    appV2Wizard.bundleVideoModalOpen,
                    toggleBundleVideoModal,
                   'https://public.zoorix.com/videos/onboarding_bundle_poster-x.webp',
                   'https://public.zoorix.com/videos/onboarding_bundle_discount.mp4'
                   )}
        {videoModal('Mix And Match Offer',
                    appV2Wizard.mixAndMatchVideoModalOpen,
                    toggleMixAndMatchVideoModal,
                   'https://public.zoorix.com/videos/onboarding_mix_match_poster-x.webp',
                   'https://public.zoorix.com/videos/onboarding_mix_match.mp4'
                   )}
        {videoModal('Volume Discount Offer Tutorial Video',
                    appV2Wizard.volumeDiscountVideoModalOpen,
                    toggleVolumeDiscountVideoModal,
                   'https://public.zoorix.com/videos/onboarding_volume_discount_poster-x.webp',
                   'https://public.zoorix.com/videos/onboarding_volume_discount.mp4'
                   )}

        </div>
    );
};

export default AppV2WizardSelectOfferType;
